<template>
  <div id="supplierRegistration" v-cloak>
    <div class="content-wrapper">
      <div class="reg-steps-wrap">
        <div class="step-num" :class="stepsCurrent>= 1 ? 'step-num-active' : ''">1</div>
        <span :class="stepsCurrent >= 1 ? 'step-title-active' : 'step-title-default'">注册用户</span>
        <div class="step-splitter">
          <div class="step-splitter-default"></div>
        </div>
        <div class="step-num" :class="stepsCurrent>= 2 ? 'step-num-active' : ''">2</div>
        <span :class="stepsCurrent >= 2 ? 'step-title-active' : 'step-title-default'">完善资料</span>
        <div class="step-splitter">
          <div class="step-splitter-default"></div>
        </div>
        <div class="step-num" :class="stepsCurrent>= 3 ? 'step-num-active' : ''">3</div>
        <span :class="stepsCurrent >= 3 ? 'step-title-active' : 'step-title-default'">完成注册</span>
      </div>
      <!--step1-->
      <div class="reg-step1-content" v-if="stepsCurrent === 1">
        <a-form :form="basicInfoForm">
          <a-form-item
            label="公司名称"
            v-bind="basicInfoItemLayout"
            :required="true"
            :validateStatus="validateStatus.companyName"
            :help="help.companyName"
          >
            <!-- <a-input
              v-decorator="['companyName', { rules: [{ required: true, message: '请输入公司名称' }, { validator: validateCompanyName }], validateTrigger: ['blur'] }]"
            /> -->
            <SearchSelect
              ref="companySelect"
              :Axios="AbpCompanyGetPaged"
              @input="handelCompanySelected"
              v-decorator="[
                'companyName',
                {
                  initialValue: '',
                },
              ]"
            >
              <!-- v-model.trim="form.companyId" -->
              <template slot="notFoundContent"> 请输入公司名称 </template>
            </SearchSelect>
          </a-form-item>
          <a-form-item
            label="信用类型"
            :labelCol="{ span: 9 }"
            :wrapperCol="{ span: 9 }"
          >
            <a-radio-group
              v-model="companyNoType"
            >
              <a-radio value="统一社会信用代码">统一社会信用代码</a-radio>
              <a-radio value="工商注册号">工商注册号</a-radio>
            </a-radio-group>
          </a-form-item>
          <a-form-item :label="companyNoType" v-bind="basicInfoItemLayout">
            <a-input
              v-decorator="['companyCode', { rules: [{ required: true, validator: validateCompanyCode }], validateTrigger: ['blur'] }]"
            />
          </a-form-item>
          <a-form-item label="用户名" v-bind="basicInfoItemLayout">
            <a-input
              v-decorator="['userName', { rules: [{ required: true, validator: this.validateUserName }], validateTrigger: ['blur'] }]"
              placeholder="请输入登录的用户名"
            />
            <div slot="extra">
              <span style="display:block">以英文字母开头，4-16位字母数字组合；</span>
              <span style="white-space:nowrap">请勿包含身份证/银行卡等隐私信息，一旦设置成功无法修改</span>
            </div>
          </a-form-item>
          <a-form-item label="经办人姓名" v-bind="basicInfoItemLayout">
            <a-input
              v-decorator="['name', { rules: [{ required: true, message: '请输入经办人姓名' }], validateTrigger: ['blur'] }]"
            />
          </a-form-item>
          <a-form-item
            label="手机号码"
            v-bind="basicInfoItemLayout"
            class="phone-wrap"
            extra="建议填写业务负责人或管理员手机号码"
          >
            <a-input
              v-decorator="['phoneNumber', {
                rules: [
                  { required: true, message: '请输入手机号码' },
                  { pattern:/^1[3456789]\d{9}$/, message: '请输入正确的手机号码' }
                ],
                validateTrigger: ['change', 'blur']
              }]"
            />
          </a-form-item>
          <a-form-item label="验证码" v-bind="basicInfoItemLayout">
            <a-row :gutter="8">
              <a-col :span="16">
                <a-input
                  placeholder="验证码"
                  v-decorator="[
                    'captchaResponse',
                    { rules: [{ required: true, validator: this.validateCaptcha }], validateTrigger: ['change', 'blur'] },
                  ]"
                >
                  <a-icon slot="prefix" type="mail" :style="{ color: 'rgba(0,0,0,.25)' }"/>
                </a-input>
              </a-col>
              <a-col :span="2" class="btn-captcha-wrap">
                <a-button
                  class="getCaptcha"
                  size="large"
                  :disabled="state.smsSendBtn"
                  @click.stop.prevent="ShowGraphCertificateModal"
                >{{ !state.smsSendBtn && '获取验证码'||(state.time+' s') }}</a-button>
              </a-col>
            </a-row>
          </a-form-item>
          <a-form-item label="电子邮箱" v-bind="basicInfoItemLayout">
            <a-input
              v-decorator="['emailAddress',{rules: [{type: 'email', required: true, validator: this.validateEmail }], validateTrigger: ['blur'] }]">
            </a-input>
          </a-form-item>
          <a-form-item label="密码" v-bind="basicInfoItemLayout">
            <a-popover placement="rightTop" trigger="click" :visible="state.passwordLevelChecked">
              <template slot="content">
                <div :style="{ width: '240px' }" >
                  <div :class="['user-register', passwordLevelClass]">强度：<span>{{ passwordLevelName }}</span></div>
                  <a-progress :percent="state.percent" :showInfo="false" :strokeColor=" passwordLevelColor " />
                  <div style="margin-top: 10px;">
                    <span>请至少输入 8 个字符。请不要使用容易被猜到的密码。（需包含数字和字母）</span>
                  </div>
                </div>
              </template>
              <a-input
                type="password"
                autocomplete="false"
                placeholder="至少 8 位密码，区分大小写"
                @mouseout="state.passwordLevelChecked = false"
                @mouseover="state.passwordLevelChecked = true"
                v-decorator="['password', {rules: [{ required: true, message: '至少 8 位密码，区分大小写'}, { validator: this.handlePasswordLevel }], validateTrigger: ['change', 'blur']}]"
              ></a-input>
            </a-popover>
          </a-form-item>
          <a-form-item label="确认密码" v-bind="basicInfoItemLayout">
            <a-input
              type="password"
              autocomplete="false"
              v-decorator="['confirmPass', { rules: [{ required: true, message: '请再次输入密码' },{validator: compareToFirstPassword}], validateTrigger: ['change', 'blur'] }]"
            />
          </a-form-item>
          <!-- <a-form-item label="公司是否开展进出口业务" v-bind="basicInfoItemLayout">
            <a-select v-decorator="['isExportBusiness', { rules: [{ required: true, message: '请选择' }] }]">
              <a-select-option value="是">是</a-select-option>
              <a-select-option value="否">否</a-select-option>
            </a-select>
          </a-form-item> -->
          <!-- <a-form-item style="text-align:center">
            <a-checkbox :checked="readSecret" @change="e => readSecret = e.target.checked">
              <span>
                已阅读并同意
              <a href="javascript:void(0)" @click="secretView = true">《隐私策略》</a>
              </span>
            </a-checkbox>
          </a-form-item> -->
          <a-form-item :wrapper-col="{ span: 12, offset: 11 }">
            <div class="btn-submit-wrap">
              <a-button type="primary" html-type="submit" @click="handleBasicInfoSubmit">
                下一步
              </a-button>
            </div>
          </a-form-item>
        </a-form>
      </div>
      <!--step2-->
      <div class="reg-step2-content" v-if="stepsCurrent === -1">
        <a-form :form="companyInfoForm">
          <a-form-item label="公司名称" v-bind="companyInfoItemLayout">
            <a-input
              disabled
              v-decorator="['companyName', { rules: [{ required: true, message: '请输入公司名称' }] }]"
            />
          </a-form-item>
          <a-form-item label="统一社会信用代码6" v-bind="companyInfoItemLayout">
            <a-input
              disabled
              v-decorator="['companyNo', { rules: [{ required: true, message: '请输入统一社会信用代码' }] }]"
            />
          </a-form-item>
          <a-form-item :required="true" label="所属区域" v-bind="companyInfoItemLayout" style="margin-bottom:0;">
            <a-form-item
              :style="{ display: 'inline-block', width: 'calc(50% - 6px)' }"
            >
              <a-select
                @change="addressChange"
                v-decorator="['area', { rules: [{ required: true, message: '请选择所属区域' }] }]"
              >
                <a-select-option v-for="province in address.provinces" :value="province.address" :key="province.code">{{ province.address }}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item
              :style="{ display: 'inline-block', width: 'calc(50% - 6px)', marginLeft: '12px' }"
            >
              <a-select
                v-decorator="['area2', { rules: [{ required: true, message: '请选择所属区域' }] }]"
              >
                <a-select-option v-for="city in address.cities" :key="city.code" :value="city.address">{{ city.address }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-form-item>
          <a-form-item label="所属行业" v-bind="companyInfoItemLayout">
            <a-select
              style="width: 100%"
              placeholder="请选择所属行业"
              v-decorator="['industry', { rules: [{ required: true, message: '请选择所属行业' }] }]"
            >
              <a-select-option v-for="item in industries" :key="item.id" :value="item.name">{{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="经营范围" v-bind="companyInfoItemLayout">
            <a-input
              v-decorator="['business', { rules: [{ required: true, message: '请输入经营范围' }] }]"
            />
          </a-form-item>
          <a-form-item label="主营产品" v-bind="companyInfoItemLayout">
            <a-input
              v-decorator="['mainProduct', { rules: [{ required: true, message: '请输入主营产品' }] }]"
            />
          </a-form-item>
          <a-form-item label="成立时间" v-bind="companyInfoItemLayout">
            <a-date-picker
              format="YYYY-MM-DD"
              style="width:100%;"
              v-decorator="['companyTime', { rules: [{ required: true, message: '请选择成立日期' }] }]">
            </a-date-picker>
          </a-form-item>
          <a-form-item label="注册资本（万元）" v-bind="companyInfoItemLayout">
            <a-input-number
              style="width:350px;"
              v-decorator="['companyCapital']"
            />
          </a-form-item>
          <a-form-item label="企业规模" v-bind="companyInfoItemLayout">
            <a-input
              v-decorator="['companyScale']"
            />
          </a-form-item>
          <a-form-item label="注册地址" v-bind="companyInfoItemLayout">
            <a-input
              v-decorator="['companyAddress', { rules: [{ required: true, message: '请输入注册地址' }] }]"
            />
          </a-form-item>
          <a-form-item label="法定代表人" v-bind="companyInfoItemLayout">
            <a-input
              v-decorator="['legalPerson']"
            />
          </a-form-item>
          <a-form-item label="营业执照" v-bind="companyUploaderLayout">
            <a-upload
              name="file"
              :action="uploadFileInit.action"
              :data="uploadFileInit.extradata"
              :beforeUpload="fileUploadBefore"
              :fileList="fileList"
              @change="handleChange"
              v-decorator="['upload-business-license', { rules: [{ required: true, message: '请上传营业执照扫描件' }] }]"
            >
              <a-button>
                <a-icon type="upload"/>
                上传文件
              </a-button>
            </a-upload>
            <span class="suggestion-wrap">支持文件类型：jpg, jpeg, png, pdf</span>
          </a-form-item>
          <a-form-item :wrapper-col="{ span: 12, offset: 11 }">
            <div class="btn-submit-wrap">
              <a-button type="primary" html-type="submit" @click="handleCompanyInfoSubmit">
                提交资料
              </a-button>
            </div>
          </a-form-item>
        </a-form>
        <!--提交成功模态框-->
        <template>
          <a-modal
            :width="460"
            :visible="submitModalVisible"
            :title="null"
            :footer="null"
            :closable="false"
            wrapClassName="submit-tips-modal"
          >
            <div class="submit-tips-wrap">
              <img src="~@/assets/success.png" height="150" width="150"/>
              <h1>提交成功，等待审核</h1>
              <div class="tips">
                该公司已被注册，现已添加您为新的用户账号,
                并提交该公司账户管理员XXX进行审核！
              </div>
            </div>
          </a-modal>
        </template>
        <!--提示已注册模态框-->
        <template>
          <a-modal
            :width="460"
            :visible="warningModalVisible"
            :title="null"
            :footer="null"
            :closable="false"
          >
            <div class="repeat-warning-tips-wrap">
              <h1>该用户名已被注册！</h1>
              <div class="btn-wrap">
                <a-button type="primary" size="large" ghost>忘记密码</a-button>
                <a-button type="primary" size="large" class="btn-primary-style">直接登录</a-button>
              </div>
            </div>
          </a-modal>
        </template>
      </div>
      <div class="reg-step3-content" v-if="stepsCurrent === 2">
        <div class="submit-wrap">
          <img src="~@/assets/success.png" height="150" width="150"/>
          <h1>注册成功</h1>
          <span>您的帐号已注册成功，现在即可登录帐号继续完善资料，<a href="javascript:;" @click="goLogin">立即登录</a></span>
        </div>
      </div>
      <!--step3-->
      <div class="reg-step3-content" v-if="stepsCurrent === 3">
        <div class="submit-wrap">
          <img src="~@/assets/success.png" height="150" width="150"/>
          <h1>注册成功</h1>
          <span>您已经注册成功，请登录系统完成平台入库审核，<a href="javascript:;" @click="goLogin">立即登录</a></span>
        </div>
      </div>
    </div>
    <!-- <a-modal v-model="secretView" :width="1100">
      <iframe frameborder="0" border="0" :src="noticeLink" style="width:1040px;height:600px;overflow:auto;margin-left:15px;margin-top:16px;"></iframe>
      <div slot="footer" >
        <a-button @click="secretView=false" type="primary">关闭</a-button>
      </div>
    </a-modal> -->
    <!-- 账户安全说明弹窗 -->
    <!-- <a-modal v-model="securityView" :width="1100">
      <iframe frameborder="0" border="0" :src="securityLink" style="width:1040px;height:600px;overflow:auto;margin-left:15px;margin-top:16px;"></iframe>
      <div slot="footer" >
        <a-button @click="securityView=false" type="primary">关闭</a-button>
      </div>
    </a-modal> -->
    <!-- 图形验证弹窗 -->
    <GraphCertificateModal ref="GraphCertificateModal" :securityUserCenterUrl="securityUserCenterUrl" :graphCertificateModalVisible="graphCertificateModalVisible" @cancel="graphCertificateModalCancel" @ok="graphCertificateModalOk"></GraphCertificateModal>
  </div>
</template>

<script>
import Vue from 'vue'
import { REGISTER_TENANT_ID } from '@/store/mutation-types'
import GraphCertificateModal from '@/components/GraphCertificateModal'
import { getRegCode, validCompany, validUser, editCompany, createFile, createCompanyInfo, validCompanyName } from '@/api/register'
import { registerBUser, getTenant } from '@/api/platformCenter' // validBUser
import { userAuditRecordCreateOrUpdate, AbpCompanyGetPaged } from '@/api/user'
import { trim } from '@/utils/util'
import { fileUtil } from '@/utils/file'
import ChineseDistricts from '@/utils/area' /* 省市联动 */
import { setWindowGlobalUrl } from '@/utils/axios'
import dayjs from 'dayjs'
import { platFormlogoImageMap } from '@/config/dict'
import { checkIsNonUserAudit, creataUserAuditData, getAUserToken, getbUserToken, getPlatformConfiguration } from '@/utils/register'
import { getUserName } from "@/utils/userCenter";
import SearchSelect from "@/components/searchSelect";
import { getCurrentPlatformSmSConfig } from "@/utils/smsConfig";

const levelNames = {
  0: '低',
  1: '低',
  2: '中',
  3: '强'
}
const levelClass = {
  0: 'error',
  1: 'error',
  2: 'warning',
  3: 'success'
}
const levelColor = {
  0: '#ff0000',
  1: '#ff0000',
  2: '#ff7e05',
  3: '#52c41a'
}

const industries = [
  {
    id: 'A',
    name: '农、林、牧、渔业'
  },
  {
    id: 'B',
    name: '采矿业'
  },
  {
    id: 'C',
    name: '制造业'
  },
  {
    id: 'D',
    name: '电力、热力、燃气及水生产和供应业'
  },
  {
    id: 'E',
    name: '建筑业'
  },
  {
    id: 'F',
    name: '批发和零售业'
  },
  {
    id: 'G',
    name: '交通运输、仓储和邮政业'
  },
  {
    id: 'H',
    name: '住宿和餐饮业'
  },
  {
    id: 'I',
    name: '信息传输、软件和信息技术服务业'
  },
  {
    id: 'J',
    name: '金融业'
  },
  {
    id: 'K',
    name: '房地产业'
  },
  {
    id: 'L',
    name: '租赁和商务服务业'
  },
  {
    id: 'M',
    name: '科学研究和技术服务业'
  },
  {
    id: 'N',
    name: '水利、环境和公共设施管理业'
  },
  {
    id: 'O',
    name: '居民服务、修理和其他服务业'
  },
  {
    id: 'P',
    name: '教育'
  },
  {
    id: 'Q',
    name: '卫生和社会工作'
  },
  {
    id: 'R',
    name: '文化、体育和娱乐业'
  },
  {
    id: 'S',
    name: '公共管理、社会保障和社会组织'
  },
  {
    id: 'T',
    name: '国际组织'
  }
]
export default {
  name: 'supplierRegistration',
  components: {
    GraphCertificateModal,
    SearchSelect
  },
  data () {
    return {
      // 自定义校验相关
      validateStatus: {
        companyName: "success",
      },
      help: {
        companyName: "",
      },
      registerPlatForm: null, // 注册的平台
      tenantId: 2, // 注册供应商
      registerRole: '供应商',
      stepsCurrent: 1, /* 默认第几步 */
      securityUserCenterUrl: null,
      createInfo: null, // 创建者的信息
      // noticeLink: 'https://z.choicelink.cn/public/contents/5647/110011.html', // 隐私策略
      // securityLink: 'https://z.choicelink.cn/public/contents/5647/121445.html', // 账号安全说明
      industries,
      graphCertificateModalVisible: false, // 图形验证弹窗
      // secretView: false,
      // securityView: false,
      readSecret: false,
      submitModalVisible: false,
      warningModalVisible: false,
      registerBtn: false,
      fileErr: false,
      // destinsuccess: false, // 营业执照识别结果
      destinCompany: '', // 识别公司名称
      destinCode: '', // 识别纳税号
      basicInfoForm: this.$form.createForm(this, { name: 'basicInfoForm' }),
      companyInfoForm: this.$form.createForm(this, { name: 'companyInfoForm' }),
      activeKeys: ['companyInfo', 'certification'], // 折叠面板默认展开项
      fileList: [],
      inteFileQuery: {
        bucket: 'choicelink',
        dir: 'choicelink-cgr/',
        fileType: 5
      },
      uploadFileInit: { // 营业执照
        action: '',
        extraData: ''
      },
      state: {
        time: 60,
        smsSendBtn: false,
        passwordLevel: 0,
        passwordLevelChecked: false,
        percent: 10,
        progressColor: '#FF0000'
      },
      basicInfoItemLayout: {
        labelCol: {
          span: 9
        },
        wrapperCol: {
          span: 7
        }
      },
      companyUploaderLayout: {
        labelCol: {
          span: 9
        },
        wrapperCol: {
          span: 12
        }
      },
      companyInfoItemLayout: {
        labelCol: {
          span: 9
        },
        wrapperCol: {
          span: 7
        }
      },
      address: {
        provinces: ChineseDistricts['86'],
        cities: []
      },
      companyNoType: '统一社会信用代码',
    }
  },
  computed: {
    passwordLevelClass () {
      return levelClass[this.state.passwordLevel]
    },
    passwordLevelName () {
      return levelNames[this.state.passwordLevel]
    },
    passwordLevelColor () {
      return levelColor[this.state.passwordLevel]
    }
  },
  async created() {
    // this.$spin.show('正在检测公司及账号信息，请稍候...')
    this.registerPlatForm = await this.getPlatformTenancyName(await this.getQueryVariable('tenantId'))
    // console.log(this.registerPlatForm)
    if (window.urlConfig && window.urlConfig.requests && window.urlConfig.requests.middlewareUrl) {
      this.securityUserCenterUrl = window.urlConfig.requests.middlewareUrl + '/security/userCenter'
    } else {
      await setWindowGlobalUrl()
      this.securityUserCenterUrl = window.urlConfig.requests.middlewareUrl + '/security/userCenter'
    }
  },
  methods: {
    AbpCompanyGetPaged,
    goLogin () {
      if (this.$route.query.tenantId && Object.keys(platFormlogoImageMap).includes(this.$route.query.tenantId)) {
        this.$router.push({
          path: '/login',
          query: { tenantId: this.$route.query.tenantId }
        })
      } else {
        this.$router.push({ path: '/login' })
      }
    },
    async getQueryVariable (variable) {
      const query = window.location.search.substring(1)
      const vars = query.split('&')
      for (let i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=')
        if (pair[0].toLocaleLowerCase() === variable.toLocaleLowerCase()) {
          return decodeURIComponent(pair[1])
        }
      }
      // 没有平台数据传递时默认注册云采链
      if (Vue.ls.get(REGISTER_TENANT_ID)) {
        return Vue.ls.get(REGISTER_TENANT_ID)
      } else {
        await setWindowGlobalUrl()
        return Vue.ls.get(REGISTER_TENANT_ID)
      }
    },
    async getPlatformTenancyName (tenantId) {
      const { result } = await getTenant({ filter: `id == "${tenantId}"` })
      this.$message.success(`您现在正在注册成为 ${result?.items[0].name} 供应商`)
      return result?.items[0].tenancyName || null
    },
    graphCertificateModalCancel () {
      this.graphCertificateModalVisible = false
    },
    graphCertificateModalOk (graphCode) {
      this.getCaptcha(graphCode)
    },
    // 显示图形验证弹窗
    ShowGraphCertificateModal () {
      this.basicInfoForm.validateFields(['phoneNumber'], { force: true },
        async (err, values) => {
          // console.log(err)
          if (!err) {
            this.graphCertificateModalVisible = true
            this.$nextTick(() => {
              // console.log(this.$refs.GraphCertificateModal)
              this.$refs.GraphCertificateModal.setPhoneNumber(values.phoneNumber)
            })
          } else {
            this.$message.error('请按要求填写手机号码')
          }
        }
      )
    },
    // 营业执照上传 // todo:营业执照识别待开发
    async handleChange (info) {
      if (this.fileErr) {
        this.fileErr = false
        setTimeout(() => {
          this.companyInfoForm.resetFields(['upload-business-license'])
        }, 100)
        return
      }
      let fileList = [...info.fileList]
      fileList = fileList.slice(-1)
      this.fileList = fileList
    },
    // 步骤2：信息完善
    handleCompanyInfoSubmit (e) { /* 公司详细信息表单 */
      e.preventDefault()
      this.companyInfoForm.validateFields(async (err, values) => {
        if (!err) {
          const companyInfo = Object.assign({ id: this.createInfo.companyId }, values)
          companyInfo.companyTime = dayjs(companyInfo.companyTime).format('YYYY-MM-DD 00:00:00')
          // ocr识别认证判断
          // companyInfo.reviewStatus = this.destinsuccess === true && (this.destinCompany === trim(values.companyName, true) && this.destinCode === trim(values.companyNo, true)) ? 1 : 0
          companyInfo.reviewStatus = false
          this.$spin.show('正在提交公司资料，请稍候...')
          try {
            await editCompany(companyInfo)
            // 创建营业执照文件
            const file = companyInfo['upload-business-license'].file.response.result
            await createFile({
              companyId: this.createInfo.companyId,
              typeName: '营业执照',
              fileName: file.displayName,
              fileId: file.id,
              fileUrl: ''
            })
            this.stepsCurrent++
          } catch (err) {
            console.error(err)
            this.$message.error('提交失败，请再尝试提交')
          } finally {
            this.$spin.hide()
          }
        }
      })
    },
    // 步骤1注册验证
    handleBasicInfoSubmit (e) { /* 账号基本信息表单 */
      e.preventDefault()
      this.basicInfoForm.validateFields(async (err, values) => {
        if (!err) {
          // // 隐私策略、账号安全说明
          // if (!this.readSecret) {
          //   this.$message.info('请先阅读并同意《隐私策略》')
          //   return
          // }
          try {
            // values.isExportBusiness = values.isExportBusiness === '是'
            // 检测账号信息
            this.$spin.show('正在检测公司及账号信息，请稍候...')
            // const validRep = await validCompany(trim(values.companyCode, true))
            // if (validRep.result) {
            //   this.$info({
            //     title: '公司已被注册',
            //     content: '该公司已被注册，请联系公司管理员直接添加账号',
            //     okText: '确定'
            //   })
            //   return
            // }
            await validUser(getUserName(values.userName), this.tenantId)
            // await validUser(values.emailAddress, this.tenantId)
            this.$spin.hide()
            const bTenantId = Vue.ls.get(REGISTER_TENANT_ID)
            // 注册账号
            this.$spin.show('正在注册账号，请稍候...')
            let parameter = {
              name: '',
              surname: values.name,
              userName: '',
              emailAddress: '',
              password: '',
              phoneNumber: '',
              captchaResponse: '',
              isActive: true,
              // reviewStatus: false,
              registerEntry: bTenantId,
              companyInput: {
                companyName: trim(values.companyName, true),
                companyNo: trim(values.companyCode, true),
                companyTel: '/',
                companyNoType: this.companyNoType,
              }
            }
            parameter = Object.assign(parameter, values)
            // 特殊处理userName
            parameter.userName = getUserName(parameter.userName);
            // console.log(parameter)
            const userRep = await createCompanyInfo(parameter, this.tenantId)
            if (!userRep.success || !userRep.result.canLogin) {
              this.$message.error(`注册失败：${userRep?.error?.message || ''}`)
              return
            }
            this.createInfo = userRep.result
            this.initUpload(this.createInfo.msg)
            // 供应商入库
            const { result: bUser, success: bUserSuc, error: bUserErr } = await this.platformUserRegister(userRep.result, parameter)
            if (!bUserSuc) {
              this.$message.error(`注册失败：${bUserErr.message}`)
              return
            }
            this.stepsCurrent++ // 下一步：信息补充
            /**
             * 添加userAudit数据
             * 1. 获取token
             * 2. 获取当前注册平台的平台设置数据
             * 3. 判断判断是否免审入库：是：创建userAudit为审核通过的数据；否：没有操作
             * 4. 免审入库的 用户添加入库审核记录表
             */
            const { A_ACCESS_TOKEN } = await getAUserToken(
              this.getUserName(values.userName),
              values.password,
              this.tenantId
            )
            const { ACCESS_TOKEN } = await getbUserToken(
              this.tenantId,
              bUser.tenantId,
              userRep.result.msg,
              A_ACCESS_TOKEN
            )
            const platformConfiguration = await getPlatformConfiguration(bUser.tenantId, {
              'Abp.TenantId': bUser.tenantId,
              Authorization: `Bearer ${ACCESS_TOKEN}`
            })
            // 如果不需要审核入库，创建审核通过的数据
            let status = ''
            let comment = ''
            if (checkIsNonUserAudit(platformConfiguration)) {
              status = '2' // 通过
              comment = '免审入库通过' // 通过
            } else {
              status = '0' // 待审核
            }
            const registerInfo = {
              companyId: userRep.result.companyId,
              companyName: trim(values.companyName, true),
              name: values.name,
              provider: this.tenantId, // aTenantId
              providerKey: userRep.result.msg, // aUserId
              tenantId: bUser.tenantId,
              userId: bUser.id,
              userName: values.userName
            }
            if (status === '2') {
              await creataUserAuditData(registerInfo, status, {
                'Abp.TenantId': bUser.tenantId,
                Authorization: `Bearer ${ACCESS_TOKEN}`
              })
              // 添加审核记录表
              const userAuditRecordParams = {
                type: '供应商入库',
                providerKey: userRep.result.msg,
                tenantId: bUser.tenantId,
                companyId: userRep.result.companyId,
                comment,
                status
              }
              await userAuditRecordCreateOrUpdate(userAuditRecordParams, {
                'Abp.TenantId': this.tenantId,
                Authorization: `Bearer ${A_ACCESS_TOKEN}`
              })
            }
            // 设置默认公司信息
            setTimeout(async () => {
              this.companyInfoForm.setFieldsValue({ companyName: values.companyName, companyNo: values.companyCode })
              if (!this.createInfo.companyId || this.createInfo.companyId.indexOf('00000000') > -1) {
                const validRep = await validCompany(trim(values.companyCode, true))
                this.createInfo.companyId = validRep.result
              }
            }, 50)
          } catch (err) {
            // console.log(err)
            const errResult = err.response.data.error.message
            if (errResult === '用户名已存在!') {
              this.$info({
                title: '用户名已存在',
                content: '用户名已存在，请使用其他用户名称',
                okText: '确定'
              })
              return
            }
            this.$message.error(`注册失败：${errResult}`)
          } finally {
            this.$spin.hide()
          }
        }
      })
    },
    async initUpload (id) {
      const { fileType, bucket, dir } = this.inteFileQuery
      this.uploadFileInit = await fileUtil.downloadInit(id, fileType, bucket, dir)
    },
    fileUploadBefore (file) {
      const suffix = fileUtil.get_suffix(file.name)
      const format = ['.jpg', '.jpeg', '.png', '.pdf']
      if (format.indexOf(suffix) < 0) {
        this.$message.info('不支持的文件格式')
        this.fileErr = true
        this.fileList = []
        return false
      }
      this.uploadFileInit.extradata.key = this.uploadFileInit.extradata.key + fileUtil.random_string(10) + suffix
      this.uploadFileInit.extradata['x:displayname'] = file.name
      this.uploadFileInit.extradata['x:objectidtype'] = '资质文件'
    },
    // 校验单位名称
    async validateCompanyName (rule, value, callback) {
      if (!value) {
        return
      }
      const validRep = await validCompanyName(trim(value, true))
      if (validRep.result) {
        callback(new Error('该单位名称已注册'))
      }
    },
    // 校验统一社会信用代码
    async validateCompanyCode (rule, value, callback) {
      if (value === null || value === '' || value.length === 0) {
        callback(new Error(`请输入${this.companyNoType}`))
        return
      }
      if (/[\u4e00-\u9fa5]/.test(value)) {
        callback(new Error('检测到输入了中文，请检查是否填写有误'))
        return
      }
      if (/[a-z]/.test(value)) {
        callback(new Error('请输入大写字母'))
        return
      }
      if (this.companyNoType === '统一社会信用代码' && value.length !== 18) {
        callback(new Error("请输入18位的统一社会信用代码"));
        return;
      }
      callback();
      // const validRep = await validCompany(trim(value, true))
      // if (validRep.result) {
      //   callback(new Error('该单位已存在'))
      // }
    },
    // 校验验证码
    async validateCaptcha (rule, value, callback) {
      if (value === null || value === '' || value.length === 0) {
        callback(new Error('请输入验证码'))
      } else if (!/^\d{6}$/.test(value)) {
        callback(new Error('请输入6位数字验证码'))
      } else {
        callback()
      }
    },
    // 校验邮箱 (注：该接口如果存在会直接500报错)
    async validateEmail (rule, value, callback) {
      if (value === null || value === '' || value.length === 0) {
        callback(new Error('请输入邮箱地址'))
      } else if (!/^([a-zA-Z\d][\w-]{2,})@(\w{2,})\.([a-z]{2,})(\.[a-z]{2,})?$/.test(value)) {
        callback(new Error('请输入正确的邮箱地址'))
      } else {
        // const validRep = await validUser(trim(value, true))
        // if (!validRep.success) {
        //   callback(new Error(validRep.error.message))
        // } else {
        callback()
        // }
      }
    },
    // 校验用户名(注：该接口如果存在会直接500报错)
    async validateUserName (rule, value, callback) {
      if (value === null || value === '' || value.length === 0) {
        callback(new Error('请输入用户名'))
      } else if (!/^[a-zA-Z][a-zA-Z0-9]{3,15}$/.test(value)) {
        callback(new Error("不符合的格式（可包含字母、数字）"));
      } else {
        const validRep = await validUser(trim(getUserName(value), true));
        if (!validRep.success) {
          callback(new Error(validRep.error.message))
        } else {
          callback()
        }
      }
    },
    // 所选区域发生变化时触发的函数--获取下一级区域的数据
    addressChange (value, option) {
      this.address.cities = []
      const options = ChineseDistricts[option.key]
      Object.keys(options).forEach(key => {
        this.address.cities.push({
          code: key,
          address: options[key]
        })
      })
    },
    // 密码安全等级处理
    handlePasswordLevel (rule, value, callback) {
      let level = 0

      // 判断这个字符串中有没有数字
      if (/[0-9]/.test(value)) {
        level++
      }
      // 判断字符串中有没有字母
      if (/[a-zA-Z]/.test(value)) {
        level++
      }
      // 判断字符串中有没有特殊符号
      if (/[^0-9a-zA-Z_]/.test(value)) {
        level++
      }
      this.state.passwordLevel = level
      this.state.percent = level * 30
      if (value.length < 8) {
        callback(new Error('密码长度不够'))
      } else {
        if (level >= 2) {
          if (level >= 3) {
            this.state.percent = 100
          }
          callback()
        } else {
          if (level === 0) {
            this.state.percent = 10
          }
          callback(new Error('密码强度不够'))
        }
      }
    },
    // 确认密码 与 密码 校验是否一致
    compareToFirstPassword (rule, value, callback) {
      const form = this.basicInfoForm
      if (value && value !== form.getFieldValue('password')) {
        callback(new Error('密码不一致!'))
      } else {
        callback()
      }
    },
    // 获取验证码
    getCaptcha (graphCode) {
      const { basicInfoForm: { validateFields }, state, $notification, $message } = this
      validateFields(['phoneNumber'], { force: true },
        async (err, values) => {
          if (!err) {
            if (!graphCode) {
              this.$message.error('请先获取图形验证码')
              return
            }
            const hide = $message.loading('验证码发送中..', 0)
            // 获取当前平台的短息网配置
            let currentPlatformSmSConfig = null
            let getSettingError = false
            try {
              currentPlatformSmSConfig = await getCurrentPlatformSmSConfig(
                Vue.ls.get(REGISTER_TENANT_ID)
              );
            } catch (error) {
              console.error(error);
              getSettingError = true
            }
            if (getSettingError) {
              this.$message.error('短信配置有误，发送失败')
              return
            }
            const parameter = {
              captcha: graphCode,
              phoneNumber: this.basicInfoForm.getFieldValue('phoneNumber'),
              action: 'Register',
              signId: currentPlatformSmSConfig.signId, // 发送短信的签名Id
              smsConfigName: currentPlatformSmSConfig.smsConfigName, // 短信网的配置name
              templateId: currentPlatformSmSConfig.templateId, // 短信网的模板Id
            }
            let interval = null
            try {
              let res = await getRegCode(parameter)
              // console.log(res)
              if (res.success) {
                res = res.result
                if (res.result.message === 'SUCCESS') {
                  setTimeout(hide, 1000)
                  $notification.success({
                    message: '提示',
                    description: '验证码已发送，请及时查看',
                    duration: 4
                  })
                  state.smsSendBtn = true
                  interval = window.setInterval(() => {
                    if (state.time-- <= 0) {
                      state.time = 60
                      state.smsSendBtn = false
                      window.clearInterval(interval)
                    }
                  }, 1000)
                  this.graphCertificateModalVisible = false
                } else {
                  // console.log(res.result)
                  this.$message.error(res.result.message)
                }
              } else {
                this.$message.error(res.error.message)
              }
              setTimeout(hide, 1)
            } catch (e) {
              setTimeout(hide, 1)
              clearInterval(interval)
              state.time = 60
              state.smsSendBtn = false
              this.$notification.error({
                message: '错误',
                description: '图形验证码错误',
                duration: 4
              })
              this.registerBtn = false
            }
          }
        }
      )
    },
    // 注册平台账户 供应商入库平台
    async platformUserRegister (aUser, parameter) {
      const params = {
        tenancyName: '' + this.registerPlatForm,
        roleName: this.registerRole,
        needAudit: false,
        userInfo: {
          companyId: aUser.companyId,
          companyName: parameter.companyInput.companyName,
          emailAddress: parameter.emailAddress,
          name: parameter.name,
          phoneNumber: parameter.phoneNumber,
          provider: '' + this.tenantId,
          providerKey: '' + aUser.msg,
          surname: parameter.name,
          userName: parameter.userName
        }
      }
      return await registerBUser(params)
    },
    /**
     * 选中公司
     */
    handelCompanySelected(val) {
      console.log(val);
      this.companySelected = { ...val };
      if (val.companyInfo) {
        this.basicInfoForm.setFieldsValue({
          companyCode: val.companyInfo.companyNo,
        });
      }
      console.log(val.companyName);
      this.basicInfoForm.setFieldsValue({
        companyName: val.companyName,
      });
      if (!val.companyName) {
        this.validateStatus.companyName = "error";
        this.help.companyName = "请输入公司名称";
      } else {
        this.validateStatus.companyName = "success";
        this.help.companyName = "";
      }
    },
  }
}
</script>

<style lang="less">
.content-wrapper {
  width: 1200px;
  // min-height: 800px;
  background: #FFF;
  margin: 0 auto;
  padding: 50px 0;
  box-shadow: 0 2px 15px 0 rgba(190,207,228,0.30);
}
[v-cloak] {
  display: none;
}

#supplierRegistration {
  // padding: 40px 0 85px 0;
  padding-bottom: 40px;
  background: #f7f7f8;
  padding-top: 40px;

  .reg-steps-wrap {
    width: 630px;
    margin: 0 auto;
    line-height: 28px;

    .step-num {
      vertical-align: top;
      display: inline-block;
      font-size: 16px;
      border-radius: 50%;
      height: 32px;
      width: 32px;
      text-align: center;
      color: rgba(0, 0, 0, 0.25);
      border: 2px solid #CCC;
    }

    .step-num-active {
      color: #fff;
      background-color: #3888FF;
      border: 2px solid #3888FF;
    }

    .step-splitter {
      vertical-align: top;
      display: inline-block;
      height: 32px;
      width: 150px;

      .step-splitter-default {
        margin: 15px;
        border-top: 1px solid #CCC;
      }
    }

    .step-title-active {
      font-size: 16px;
      color: #333;
      margin-left: 7px;
      font-weight: bold;
      line-height: 32px;
    }

    .step-title-default {
      font-size: 16px;
      color: #999;
      margin-left: 7px;
      line-height: 32px;
    }
  }

  .reg-step1-content {
    padding: 40px 0;

    .ant-input {
      height: 36px !important;
    }

    .ant-form-explain {
      margin-bottom: 3px;
    }

    .ant-form-extra {
      margin-bottom: 3px;
    }

    .btn-captcha-wrap {
      .ant-btn {
        height: 36px !important;
        padding: 6px 20px !important;

        &:hover {
          color: #3888FF !important;
          border-color: #3888FF !important;
        }

        &:focus {
          color: #3888FF !important;
          border-color: #3888FF !important;
        }
      }
    }

    .btn-submit-wrap {
      button {
        background: #3888FF !important;
        border-color: #3888FF !important;
        border-radius: 4px;
        width: 120px;
        height: 40px;
      }
    }

    .phone-wrap {
      .ant-form-explain {
        margin: 0;
      }
      .ant-form-extra {
        font-size: 12px;
        color: #999;
      }
    }

    .getCaptcha {
      height: 40px;
      font-size: 14px;
      min-width: 110px;
    }

    .user-register {

      &.error {
        color: #ff0000;
      }

      &.warning {
        color: #ff7e05;
      }

      &.success {
        color: #52c41a;
      }

    }
  }

  .reg-step2-content {
    padding: 40px 0;
    // margin: 0 auto;

    .ant-collapse {
      > .ant-collapse-item {
        > .ant-collapse-header {
          background: #f4f4f4;
          border-left: 3px solid #3888FF;
          margin-top: 30px;
        }
      }
    }

    .ant-input {
      height: 36px;
    }

    .ant-form-explain {
      margin-bottom: 3px;
    }

    .ant-form-extra {
      margin-bottom: 3px;
    }

    .collapse-header {
      position: relative;

      .collapse-title {
        font-size: 18px;
        font-weight: bold;
      }

      .collapse-btn {
        display: inline-block;
        position: absolute;
        right: 20px;
        color: #3888FF;
        cursor: pointer;
      }
    }

    .collapse-content-common {
      padding-top: 30px;

      .ant-btn {
        &:hover {
          color: #3888FF !important;
          border-color: #3888FF !important;
        }

        &:focus {
          color: #3888FF !important;
          border-color: #3888FF !important;
        }
      }
    }

    .btn-final-submit-wrap {
      text-align: center;
      padding-top: 30px;

      button {
        background: #3888FF !important;
        border-color: #3888FF !important;
        border-radius: 4px;
        min-width: 200px;
        height: 46px;
      }
    }

    .btn-submit-wrap {
      button {
        background: #3888FF !important;
        border-color: #3888FF !important;
        border-radius: 4px;
        width: 120px;
        height: 40px;
      }
    }

    .suggestion-wrap {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: #333;
    }
  }

  .reg-step3-content {
    .submit-wrap {
      font-family: PingFangSC-Regular;
      text-align: center;
      margin-top: 120px;
      font-size: 14px;

      h1 {
        font-weight: bold;
        font-size: 20px;
        line-height: 28px;
        margin: 0;
      }

      a {
        font-size: 14px;
      }

      span {
        line-height: 36px;
        color: #333;
      }
    }
  }
  .role-item {
    img {
      width: 80px;
      height: 80px;
    }
    h2 {
      display: inline-block;
      color: #048df2;
      font-weight: bolder;
      font-size: 28px;
      vertical-align: -webkit-baseline-middle;
      margin-left: -5px;
    }
  }
  .content-container {
    width: calc(100% - 40px);
    min-height: 100px;
    background: #ecf8ff;
    padding: 20px 25px;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    margin: 0 20px;
    h2 {
      font-size: 17px;
      font-weight: bold;
      color: #048df2;
    }
    h3 {
      color: #86a1b5;
      font-size: 14px;
    }
  }
}

/* 模态框-提交成功-提示 */
.submit-tips-modal {
  top: 5%;
  min-height: 306px;
  overflow-y: hidden;

  .submit-tips-wrap { /* 审核成功 */
    font-family: SourceHanSansCN-Normal;
    text-align: center;
    color: #333333;
    padding-bottom: 15px;

    h1{
      font-weight: bold;
      font-size: 20px;
      margin: 0 0 15px 0;
      line-height: 28px;
    }

    .tips {
      width: 325px;
      font-size: 16px;
      margin: 0 auto;
      line-height: 24px;
    }
  }
}

.repeat-warning-tips-wrap { /* 重复注册 */
  font-family: SourceHanSansCN-Normal;
  padding-bottom: 30px;

  h1 {
    font-size: 20px;
    line-height: 30px;
    color: #333333;
    text-align: center;
    padding: 21px 0;
  }

  .btn-wrap {
    text-align: center;
    .ant-btn-background-ghost.ant-btn-primary {
      border-color: #1890ff !important;
      &:hover {
        color: #1890ff !important;
      }
      &:focus {
        color: #1890ff !important;
      }
    }
    .btn-primary-style {
      background-color: #1890ff !important;
      border-color: #1890ff !important;
      margin-left: 30px;
    }
  }
}
</style>
